export default "__VITE_ASSET__D8iLomh0__"